// Compact human-readable formatters used across catalog and detail screens.

/** $268,000 -> "$268k", $1,250,000 -> "$1.25M" */
export const formatPriceCompact = (n) => {
  if (n == null) return "—";
  if (n >= 1_000_000) {
    return `$${(n / 1_000_000).toFixed(n >= 10_000_000 ? 0 : 2).replace(/\.?0+$/, "")}M`;
  }
  if (n >= 1_000) return `$${Math.round(n / 1_000)}k`;
  return `$${n}`;
};

/** $268,000 with thousands separators (used on detail-view costing panel). */
export const formatPriceFull = (n) =>
  n == null ? "—" : `$${Number(n).toLocaleString("en-US")}`;

/** "1,541" */
export const formatInt = (n) =>
  n == null ? "—" : Number(n).toLocaleString("en-US");

/** "single_family" -> "Single-Family", "cottage_missing_middle" -> "Cottage / Missing-Middle" */
export const formatTypology = (t) => {
  if (!t) return "";
  if (t === "single_family") return "Single-Family";
  if (t === "adu") return "Accessory Dwelling";
  if (t === "duplex") return "Duplex";
  if (t === "cottage_missing_middle") return "Cottage / Missing-Middle";
  return t.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};

export const formatStatusLabel = (s) => {
  const map = {
    vacant_available: "Vacant — Available",
    structure_present: "Structure Present",
    in_review: "In Review",
    under_contract: "Under Contract",
  };
  return map[s] || s;
};

export const formatStatusTone = (s) => {
  const map = {
    vacant_available: "accent",
    structure_present: "warn",
    in_review: "success",
    under_contract: "info",
  };
  return map[s] || "info";
};

/** Resolve a backend-relative asset URL to a fully-qualified one. */
export const assetUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return `${base}${path}`;
};
